import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/common/Header";
import AdBlockChecker from "./components/common/AdBlockChecker";
import { HelmetProvider, Helmet } from "react-helmet-async"; // NEU

import AnimatedRoutes from "./AnimatedRoutes";
import "./assets/css/app.css";
import "./assets/css/upload-image.css";

/** ---------- Ab hier: robuster Fix ---------- **/

// Hilfsfunktionen
function forceIPRStyle(el) {
  try {
    el.style.setProperty("position", "fixed", "important");
    el.style.setProperty("bottom", "0", "important");
    el.style.setProperty("right", "0.25rem", "important");
    return true;
  } catch {
    return false;
  }
}

// Sucht das Ziel-Element auf mehreren Wegen:
// 1) .ipr-container
// 2) ein div mit dem markanten Inline-Style-Signatur-Teil (-webkit-text-fill-color: unset)
function findIprCandidate() {
  let el = document.querySelector(".ipr-container");
  if (el) return el;

  el = Array.from(
    document.querySelectorAll('div[style*="-webkit-text-fill-color: unset"]')
  ).pop();
  if (el) return el;

  // optional: falls du selbst ein data-Attribut setzen kannst
  el = document.querySelector("[data-ipr-container]");
  return el || null;
}

// BODY-Style hart entfernen (falls AdScripts daran rumfummeln)
const bodyObserver = new MutationObserver(() => {
  document.body.removeAttribute("style");
});
bodyObserver.observe(document.body, { attributes: true, attributeFilter: ["style"] });

// Beobachter für das Ziel-Element + DOM-Zugänge
const iprObserver = new MutationObserver((mutations) => {
  for (const m of mutations) {
    if (m.type === "attributes" && m.attributeName === "style") {
      forceIPRStyle(m.target);
    }
    if (m.type === "childList" && (m.addedNodes?.length || m.removedNodes?.length)) {
      const el = findIprCandidate();
      if (el) {
        forceIPRStyle(el);
        try {
          iprObserver.observe(el, { attributes: true, attributeFilter: ["style"] });
        } catch { /* noop */ }
      }
    }
  }
});

// Gesamten DOM-Baum auf neu hinzukommende Nodes beobachten
iprObserver.observe(document.documentElement, { childList: true, subtree: true });

// Falls das Element bereits vorhanden ist, sofort stylen + direkt beobachten
const initialEl = findIprCandidate();
if (initialEl) {
  forceIPRStyle(initialEl);
  iprObserver.observe(initialEl, { attributes: true, attributeFilter: ["style"] });
}

// Fallback-Intervall
const __IPR_FORCE_TIMEOUT_MS = 15000; // 15s
const __IPR_FORCE_INTERVAL_MS = 500;  // alle 500ms
const __iprIntervalStart = Date.now();

const __iprInterval = setInterval(() => {
  const el = findIprCandidate();
  if (el) forceIPRStyle(el);

  if (Date.now() - __iprIntervalStart > __IPR_FORCE_TIMEOUT_MS) {
    clearInterval(__iprInterval);
  }
}, __IPR_FORCE_INTERVAL_MS);

/** ---------- Ende Fix ---------- **/

const App = () => {
  return (
    <AuthProvider>
      <HelmetProvider>
        {/* Globale Defaults & Template */}
        <Helmet defaultTitle="NGCTV" titleTemplate="%s | NGCTV">
          <meta name="description" content="NGCTV – News, Tests & Reviews" />
        </Helmet>

        <BrowserRouter>
          <AdBlockChecker>
            <Header />
            <AnimatedRoutes />
          </AdBlockChecker>
        </BrowserRouter>
      </HelmetProvider>
    </AuthProvider>
  );
};

export default App;
